import {
  Component,
  OnInit,
} from '@angular/core';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { AuctionService, LaunchDarklyService } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';


@Component({
    selector: 'app-make-hold-modal',
    templateUrl: './make-hold-modal.component.html',
    styleUrls: ['./make-hold-modal.component.scss'],
    imports: [TranslocoDirective]
})
export class MakeHoldModalComponent extends ChangeStatusModalDirective implements OnInit {
  textHoldVehicles: string;
  textHoldVehicle: string;
  textSelectingVehicles: string;
  textSelectingVehicle: string;

  constructor(store: Store, auctionService: AuctionService, readonly launchDarklyService: LaunchDarklyService, readonly translocoService: TranslocoService) {
    super(store, auctionService, launchDarklyService, translocoService);
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textHoldVehicles;
    } else {
      return this.textHoldVehicle;
    }
  }

  get modalBody() {
    if (this.selectedVehicles.length > 1) {
      return this.textSelectingVehicles;
    } else {
      return this.textSelectingVehicle;
    }
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.makeHoldModal')
      .subscribe(translate => {
        this.textHoldVehicles = translate.textHoldVehicles;
        this.textHoldVehicle = translate.textHoldVehicle;
        this.textSelectingVehicles = translate.textSelectingVehicles;
        this.textSelectingVehicle = translate.textSelectingVehicle;
      });
  }
}
